import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { css } from '@emotion/core';
import generateBgStyleByType from 'styles/generateBgStyleByType';
import { bgTypes } from 'styles/generateBgStyleByType';
import { useLocation } from 'react-router-dom';
import CoverBgSVG, { SVG_TYPES } from 'components/CoverPage/CoverBgSVG';
import { COVER_TABS } from 'editor/components/CoverPage/config';
import { joinRegex } from 'client/hooks/useInitPromo/useInitPromo';
import { useContentBgColorIntegration } from 'hooks/useThemeStyleIntegration';
import useCoverSettingComponentStyle from 'hooks/useCoverSettingComponentStyle';

const Background = () => {
    const location = useLocation();
    const { bgType, bgColor, bgImgUrl, bgMobileImgUrl } = useSelector(s => s.settingStyle);
    const { contentBgColor } = useContentBgColorIntegration();
    const coverSettingStyle = useCoverSettingComponentStyle();
    const { enableCoverPage } = useSelector(s => s.settingPromo);
    const { isCoverPagePhase } = useSelector(s => s.userEntryState);
    const isJoinPage = Boolean(location.pathname.match(joinRegex));
    let isCoverPage = enableCoverPage && isCoverPagePhase && isJoinPage;

    const showSVGBg =
        isCoverPage &&
        coverSettingStyle.backgroundEnabled &&
        coverSettingStyle.backgroundTab === COVER_TABS.PRESET &&
        coverSettingStyle.backgroundType === bgTypes.SVG;
    const coverPageBgColor = coverSettingStyle.backgroundColor || contentBgColor;
    const shouldShowMask = !isCoverPage || !coverSettingStyle.backgroundEnabled;

    const getBgSetting = () => {
        if (!isCoverPage || !coverSettingStyle.backgroundEnabled) {
            return {
                type: bgType,
                imageUrl: bgImgUrl,
                mobileImgUrl: bgMobileImgUrl,
                color: bgColor
            };
        }

        if (coverSettingStyle.backgroundEnabled) {
            return coverSettingStyle.backgroundTab === COVER_TABS.PRESET
                ? {
                      type: coverSettingStyle.backgroundType,
                      imageUrl: '',
                      mobileImgUrl: '',
                      color: coverPageBgColor
                  }
                : {
                      type: bgTypes.IMG,
                      imageUrl: coverSettingStyle.backgroundDesktopImg,
                      mobileImgUrl: coverSettingStyle.backgroundMobileImg
                  };
        }
    };
    return (
        <>
            <div
                css={[
                    bgStyle,
                    css(
                        generateBgStyleByType({
                            isFixedMode: true,
                            ...getBgSetting()
                        })
                    )
                ]}
            />
            {Boolean(showSVGBg) && (
                <CoverBgSVG
                    type={SVG_TYPES.COVER_01}
                    bgColor={coverPageBgColor}
                    customStyle={coverSVGBgStyle}
                />
            )}
            {shouldShowMask && <div css={maskStyles(contentBgColor)} />}
        </>
    );
};

export default memo(Background);

const bgStyle = css`
    position: fixed;
    height: 100%;
    width: 100%;
    z-index: -999999;
`;

const coverSVGBgStyle = css`
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: -999999;

    object-fit: cover;
    min-height: 100vh;
    min-width: 100vw;

    @media (max-width: 768px) {
        width: 200%;
        height: 100vh;
        position: fixed;
        left: -50%;
        top: 0;
    }
`;
const maskStyles = contentBgColor => css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -999999;
    background-color: ${contentBgColor};
`;
